import {Component, Input, OnInit} from '@angular/core';
import {fdeBloombergHoldingObject} from "../../../../../common/it-interface";
import {convertToSnakeCase} from "../../../../../common/it-utils";
import {SIDE_NAV_TITLES} from "../../../../../common/it-constants";

@Component({
  selector: 'app-bbg-holding-table',
  templateUrl: './bbg-holding-table.component.html',
  styleUrls: ['./bbg-holding-table.component.scss']
})
export class BbgHoldingTableComponent implements OnInit{

  @Input() tableDataShow: string;
  @Input() listOfBbgHoldingByHstDate: fdeBloombergHoldingObject[];

  fundDayEndReportKey = convertToSnakeCase(SIDE_NAV_TITLES.fundDayEndReport);

  constructor() {}

  ngOnInit() {
    this.listOfBbgHoldingByHstDate = [];
  }

}
